import { render } from "./SimpleModelViewer.vue?vue&type=template&id=cbf99acc&scoped=true"
import script from "./SimpleModelViewer.vue?vue&type=script&lang=js"
export * from "./SimpleModelViewer.vue?vue&type=script&lang=js"

import "./SimpleModelViewer.vue?vue&type=style&index=0&id=cbf99acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf99acc"]])

export default __exports__